const CartDrawer = {
  buttons: document.querySelectorAll('[data-toggle-cart]'),
  selector: '[data-cart-count]',
  attr: '[data-cart-count-attr]',
  text: '[data-cart-item-text]',

  getCartItens: async function() {
    try {
      const itens = await $.ajax({
        url: '/carrinho/itens',
        type: 'GET',
        dataType: 'text',
      })
      return itens;
    } catch (error) {
      console.error('Erro ao buscar a quantidade de produtos do carrinho');
      console.error(error);
    }
  },

  initCart: function () {
    let newStyle = document.createElement('link');
    newStyle.rel = 'stylesheet';
    newStyle.href = window.componentCart.css;
    document.body.appendChild(newStyle);
    
    let newScript = document.createElement('script');
    newScript.src = window.componentCart.js;
    document.body.appendChild(newScript);

    console.log('newStyle', newStyle);
    console.log('newScript', newScript);

    newScript.onload = () => {
      let freeShipping = window._freeShipping ? window._freeShipping : 0;

      window.componentCartDrawer = new Vnda.Component.CartDrawer({
        display: 'list',
        start_open: false,
        anchor: 'right',
        freeShipping,
        disableShippingCalculation: true,
      });
      componentCartDrawer.render(document.getElementById('component-cart-drawer-root'));
      componentCartDrawer.open();
    }
  },

  updateCartCount: async function(_itemsCount = null) {
    const count = document.querySelector('[data-cart-count-attr]');
    const value =
      localStorage.getItem('cart-count')
        ? localStorage.getItem('cart-count')
        : 0

    count.innerHTML = value;
    count.setAttribute('data-cart-count-attr', value);
    console.log('count', value);
  },

  toggleCart: function () {
    if (this.buttons.length > 0) this.buttons.forEach(button => {
      button.addEventListener('click', () => { CartDrawer.show() });
    });
  },

  updateShippingBar: function () {
    const root = document.getElementById('component-cart-drawer-root');
    const selector = '.cmp-cart-drawer-free-shipping-progress';
    
    const observer = new MutationObserver((mutationsList) => {
      if (root.querySelector(selector) && !root.querySelector(`${selector}.-gift`)) {
        root.querySelector(selector).classList.add('-gift');

        let textEl = root.querySelector('.vnda-shipping-text');
        let text = textEl.innerText;

        if (text.includes('VOCÊ GANHOU FRETE GRÁTIS')) {
          textEl.innerHTML = 'VOCÊ GANHOU O BRINDE';

        } else {
          let value = Number(text.split('R$ ')[1].split(' PARA')[0].replace(',', '.'));
          textEl.innerHTML = `FALTAM ${formatMoney(value)} PARA O BRINDE`;

        }
      }
    });
    
    observer.observe(root, { attributes: true, childList: true, subtree: true });
  },

  updateCount: function () {
    const root = document.getElementById('component-cart-drawer-root');
    const count = document.querySelector('[data-cart-count-attr]');
    const selector = '.cart-buttons-amount';
    const empty = '.cmp-cart-drawer-items p';
    
    const observer = new MutationObserver((mutationsList) => {
      if (root.querySelector(selector)) {
        let value = 0;
        let spans = root.querySelectorAll(selector);
        if (spans.length > 0)
          spans.forEach(span => { value += Number(span.innerText) });

        count.innerHTML = value;
        count.setAttribute('data-cart-count-attr', value);
        localStorage.setItem('cart-count', value);
        console.log('count', value);

      } else if (root.querySelector(empty)) {
        count.innerHTML = 0;
        count.setAttribute('data-cart-count-attr', 0);
        localStorage.setItem('cart-count', 0);
        console.log('count', 0);

      }
    });
    
    observer.observe(root, { attributes: true, childList: true, subtree: true, characterData: true });
  },
  
  show: function () {
    window.componentCartDrawer 
      ? window.componentCartDrawer.open() 
      : CartDrawer.initCart()
  },

  init: function() {
    const _this = this;
    
    _this.updateCartCount();
    _this.toggleCart();
    _this.updateShippingBar();
    _this.updateCount();
  }
};

export default CartDrawer;
